import { render, staticRenderFns } from "./Moderator.vue?vue&type=template&id=2039845b&scoped=true"
import script from "./Moderator.vue?vue&type=script&lang=js"
export * from "./Moderator.vue?vue&type=script&lang=js"
import style0 from "./Moderator.vue?vue&type=style&index=0&id=2039845b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2039845b",
  null
  
)

export default component.exports